import axios from 'axios';
import { ECOMMERCE_API_URL, CONTENT_API_URL, COMMERCEMEDIA_API_URL } from './_constants';
import logger from 'helpers/logger';

export const getRelatedProductBySkuFromAdapter: (
	productSku: string,
	accessToken: any,
	locale: string,
	bpId?: string,
	country?: string,
) => Promise<Models.CategoryProduct> = async (
	productSku,
	accessToken,
	locale,
	bpId,
	country,
) => {
	const method = 'GET';
	const headers = {};
	headers['Authorization'] = `Bearer ${accessToken}`;
	let path = `GetRelatedProducts/?sku=${productSku}`;

	if (bpId) {
		path += `&bpId=${bpId}`;
	}
	const ecommerceUrl = ECOMMERCE_API_URL;
	const endpointUrl = `${ecommerceUrl}${path}`;

	return axios({
		url: endpointUrl,
		method: method,
		maxRedirects: 0,
		headers,
	})
		.then((res) => {
			const { data } = res;
			if (!data) {
				return null;
			}			
			return data;
		})
		.catch((error) => {
			logger.error(`getRelatedProductBySkuFromAdapter ${error}`);
			throw new Error(error);
		});
};